/* cf-rail-arrows.js
   Document-level prev/next arrow + scroll-disabled handling for any
   [data-cf-rail] section. Uses click delegation + MutationObserver so it
   works equally for server-rendered rails (home page chaos-featured-collection)
   and AJAX-injected rails (PDP product-recommendations — Shopify's custom
   element replaces innerHTML with the section response, and inline <script>
   tags inserted that way do NOT execute, which is why a per-section inline
   handler is unreliable). */
(function () {
  function getContext(button) {
    var rail = button.closest('[data-cf-rail]');
    if (!rail) return null;
    var track = rail.querySelector('[data-cf-rail-track]');
    if (!track) return null;
    return { rail: rail, track: track };
  }

  function syncDisabled(track) {
    var rail = track.closest('[data-cf-rail]');
    if (!rail) return;
    var prev = rail.querySelector('[data-cf-rail-prev]');
    var next = rail.querySelector('[data-cf-rail-next]');
    if (prev) prev.disabled = track.scrollLeft <= 1;
    if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
  }

  function bindTrack(track) {
    if (track.__cfRailBound) return;
    track.__cfRailBound = true;
    track.addEventListener('scroll', function () { syncDisabled(track); }, { passive: true });
    window.addEventListener('resize', function () { syncDisabled(track); });
    requestAnimationFrame(function () { syncDisabled(track); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cf-rail-prev], [data-cf-rail-next]');
    if (!btn) return;
    if (btn.disabled) return;
    var ctx = getContext(btn);
    if (!ctx) return;
    var card = ctx.track.querySelector('.cf-rail__card');
    if (!card) return;
    var styles = window.getComputedStyle(ctx.track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 16;
    var dir = btn.matches('[data-cf-rail-prev]') ? -1 : 1;
    ctx.track.scrollBy({ left: dir * (card.offsetWidth + gap), behavior: 'smooth' });
  });

  function init() {
    document.querySelectorAll('[data-cf-rail-track]').forEach(bindTrack);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('[data-cf-rail-track]')) {
          bindTrack(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll('[data-cf-rail-track]').forEach(bindTrack);
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
